// UK time on screen, whatever timezone the browser is set to — same helper
// as nano-fibre-fsm/client/src/utils/ukTime.js;
// every time and date on Absence Reporting is a UK working day.
export const UK = 'Europe/London';

function ukParts(date) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: UK, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type).value;
  return { year: get('year'), month: get('month'), day: get('day'), hour: get('hour'), minute: get('minute') };
}

// True when two instants fall on the same UK calendar day.
export function isSameUkDay(a, b) {
  const pa = ukParts(a);
  const pb = ukParts(b);
  return pa.year === pb.year && pa.month === pb.month && pa.day === pb.day;
}

// 'dd/MM/yyyy' and 'HH:mm' of an instant, in UK time — the text formats
// the form's date/time answers are stored in.
export function toUkDateText(date) {
  const p = ukParts(date);
  return `${p.day}/${p.month}/${p.year}`;
}
export function toUkTimeText(date) {
  const p = ukParts(date);
  return `${p.hour}:${p.minute}`;
}

// The instant a UK wall-clock date/time ('dd/MM/yyyy', 'HH:mm') happens —
// self-correcting for BST/GMT. null if the date doesn't parse.
export function ukWallClockToDate(ukDate, time = '00:00') {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(ukDate || '');
  if (!m) return null;
  const [hh, mm] = (time || '00:00').split(':').map(Number);
  const guess = Date.UTC(Number(m[3]), Number(m[2]) - 1, Number(m[1]), hh || 0, mm || 0);
  const p = ukParts(new Date(guess));
  const shownAsUtc = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute));
  return new Date(guess - (shownAsUtc - guess));
}

// Whole UK calendar days from instant `a` to instant `b` (0 on the same UK
// day) — counted on calendar dates, so a clock change can't shift it.
export function ukDaysBetween(a, b) {
  const toUtcMidnight = (d) => {
    const [dd, mm, yyyy] = toUkDateText(d).split('/').map(Number);
    return Date.UTC(yyyy, mm - 1, dd);
  };
  return Math.round((toUtcMidnight(b) - toUtcMidnight(a)) / 86400000);
}
